<template>
  <modal :show="true" :large="true" v-on:close="closeModal">
    <div class="w-100" slot="title">
      <div class="d-flex w-100 justify-content-between">
        <h4>Add Occupant</h4>
        <button
          class="btn-primary btn btn-sm"
          type="button"
          v-on:click="copyThirdPartyDetails"
          :disabled="!thirdParty"
        >
          Copy Third Party Details
        </button>
      </div>
    </div>
    <div class="row">
      <div class="col-xl-12">
        <div class="form-horizontal">
          <selectlist
            name="type"
            :options="types"
            v-model="form.type_id"
            label="Occupant Type"
            placeholder="Please Select"
            helper="Please select the type of occupant"
          ></selectlist>

          <inputbox
            v-model="form.first_name"
            name="first_name"
            label="First Name"
            helper="Please enter the first name of the occupant"
          ></inputbox>

          <inputbox
            v-model="form.last_name"
            name="last_name"
            label="Last Name"
            helper="Please enter the last name of the occupant"
          ></inputbox>

          <date-of-birth
            v-model="form.date_of_birth"
            name="date_of_birth"
            :unlimited="true"
            helper="Please enter the occupants date of birth"
          ></date-of-birth>

          <inputbox
            v-model="form.occupation"
            name="occupation"
            label="Occupation"
            helper="Please enter the occupants occupation"
          ></inputbox>

          <inputbox
            v-model="form.medical_conditions"
            name="medical_conditions"
            helper="If the occpuant has any medical conditions, enter them here"
            label="Medical Conditions"
          ></inputbox>

          <inputbox
            v-model="form.relation_to_third_party"
            name="relation_to_client"
            helper="What relation is the occupant to the third party?"
            label="Relation to Third Party"
          ></inputbox>

          <inputbox
            v-model="form.national_insurance"
            name="national_insurance_number"
            helper="Please enter the occupants national insurance number"
            label="National Insurance Number"
          ></inputbox>

          <selectlist
            :options="positions"
            v-model="form.position_id"
            label="Seat/Position"
            placeholder="Please Select"
            name="position"
            helper="Please choose the position where the occupant was in the vehicle"
          ></selectlist>

          <div class="form-group">
            <div class="col-lg-4">
              <label class="control-label">Requires Glasses?</label>
            </div>
            <div class="col-lg-8">
              <toggleswitch
                :labels="true"
                name="requires_glasses"
                helper="Does the occupant require glasses?"
                v-model="form.requires_glasses"
              ></toggleswitch>
            </div>
          </div>

          <div class="form-group">
            <div class="col-lg-4">
              <label class="control-label">Wearing Seatbelt?</label>
            </div>
            <div class="col-lg-8">
              <toggleswitch
                :labels="true"
                name="wearing_seatbelt"
                helper="Was the occupant wearing a seatbelt?"
                v-model="form.wearing_seatbelt"
              ></toggleswitch>
            </div>
          </div>

          <fieldset>
            <legend>
              Contact Details
              <small class="text-muted"
                >- Enter the occupants contact details here</small
              >
            </legend>

            <inputbox
              v-model="form.telephone"
              name="telephone"
              label="Telephone"
              helper="Please enter a contact telephone number for the occupant"
            ></inputbox>

            <inputbox
              v-model="form.email_address"
              name="email"
              label="Email Address"
              type="email"
              helper="Please enter the email address for the occupant"
            ></inputbox>
          </fieldset>
          <fieldset>
            <legend>
              Address Details
              <small class="text-muted"
                >- Enter the occupants address details here</small
              >
            </legend>
            <address-lookup
              name="addresses"
              :address="address"
              v-on:address="setAddress"
            ></address-lookup>
          </fieldset>
          <fieldset>
            <legend>
              Injury Details
              <small class="text-muted"
                >- Enter the occupants injury details here</small
              >
            </legend>

            <input-block
              v-model="form.injury_details"
              name="injury_details"
              label="Injury Details"
              helper="Please enter a description of the occupant's injury"
            ></input-block>

            <div class="form-group">
              <div class="col-lg-4">
                <label class="control-label">Has Representation?</label>
              </div>
              <div class="col-lg-8">
                <toggleswitch
                  :labels="true"
                  name="has_representation"
                  helper="Does the occupant have representation already?"
                  v-model="form.has_representation"
                ></toggleswitch>
              </div>
            </div>

            <div v-if="form.has_representation">
              <inputbox
                v-model="form.representation_company_name"
                name="representation_company_name"
                label="Company Name"
                helper="Please enter the name of the company representing the occupant"
              ></inputbox>

              <inputbox
                v-model="form.representation_reference"
                name="representation_reference"
                label="Reference"
                helper="Please enter the reference for the occupants injury"
              ></inputbox>

              <inputbox
                v-model="form.representation_email"
                name="representation_email"
                label="Email"
                helper="Please enter an email address for the company representing the occupant"
              ></inputbox>

              <inputbox
                v-model="form.representation_telephone"
                name="representation_telephone"
                label="Telephone"
                helper="Please enter a telephone number for the company representing the occupant"
              ></inputbox>
            </div>

            <div class="form-group">
              <div class="col-lg-4">
                <label class="control-label">Any lacerations?</label>
              </div>
              <div class="col-lg-8">
                <toggleswitch
                  :labels="true"
                  name="any_lacerations"
                  v-model="form.any_lacerations"
                ></toggleswitch>
              </div>
            </div>

            <div class="form-group">
              <div class="col-lg-4">
                <label class="control-label">Any bleeding?</label>
              </div>
              <div class="col-lg-8">
                <toggleswitch
                  :labels="true"
                  name="any_bleeding"
                  v-model="form.any_bleeding"
                ></toggleswitch>
              </div>
            </div>

            <div class="form-group">
              <div class="col-lg-4">
                <label class="control-label">Any head wounds?</label>
              </div>
              <div class="col-lg-8">
                <toggleswitch
                  :labels="true"
                  name="any_head_wounds"
                  v-model="form.any_head_wounds"
                ></toggleswitch>
              </div>
            </div>

            <div class="form-group">
              <div class="col-lg-4">
                <label class="control-label">Any disorientation?</label>
              </div>
              <div class="col-lg-8">
                <toggleswitch
                  :labels="true"
                  name="any_disorientation"
                  v-model="form.any_disorientation"
                ></toggleswitch>
              </div>
            </div>

            <div class="form-group">
              <div class="col-lg-4">
                <label class="control-label">Any fractures or breaks?</label>
              </div>
              <div class="col-lg-8">
                <toggleswitch
                  :labels="true"
                  name="any_fractures_or_breaks"
                  v-model="form.any_fractures_or_breaks"
                ></toggleswitch>
              </div>
            </div>

            <div class="form-group">
              <div class="col-lg-4">
                <label class="control-label">Any fatalities?</label>
              </div>
              <div class="col-lg-8">
                <toggleswitch
                  :labels="true"
                  name="any_fatalities"
                  v-model="form.any_fatalities"
                ></toggleswitch>
              </div>
            </div>

            <div class="form-group">
              <div class="col-lg-4">
                <label class="control-label"
                  >Was there any loss of consciousness?</label
                >
              </div>
              <div class="col-lg-8">
                <toggleswitch
                  :labels="true"
                  name="any_loss_of_consciousness"
                  v-model="form.any_loss_of_consciousness"
                ></toggleswitch>
              </div>
            </div>

            <div class="form-group">
              <div class="col-lg-4">
                <label class="control-label">Did the police attend?</label>
              </div>
              <div class="col-lg-8">
                <toggleswitch
                  :labels="true"
                  name="police_attend"
                  v-model="form.police_attend"
                ></toggleswitch>
              </div>
            </div>

            <div class="form-group">
              <div class="col-lg-4">
                <label class="control-label"
                  >Did an ambulance or air ambulance attend?</label
                >
              </div>
              <div class="col-lg-8">
                <toggleswitch
                  :labels="true"
                  name="ambulance_or_air_ambulance_attend"
                  v-model="form.ambulance_or_air_ambulance_attend"
                ></toggleswitch>
              </div>
            </div>
          </fieldset>
        </div>
      </div>
    </div>
    <div slot="footer">
      <button type="button" v-on:click="closeModal" class="btn btn-danger">
        Close
      </button>
      <form-button
        :indicator="form.processing()"
        v-on:clicked="addThirdPartyOccupant"
        >Add New Occupant</form-button
      >
    </div>
  </modal>
</template>
<script>
export default {
  props: {
    incident: {
      type: String,
      required: true
    },

    thirdParty: {
      type: Object,
      required: true
    },

    types: {
      type: Array,
      required: true
    },

    positions: {
      type: Array,
      required: true
    },

    client: {
      type: Object
    }
  },

  data() {
    return {
      form: new window.Form({
        type_id: null,
        first_name: null,
        last_name: null,
        date_of_birth: null,
        occupation: null,
        medical_conditions: null,
        relation_to_third_party: null,
        national_insurance: null,
        position_id: null,
        requires_glasses: false,
        wearing_seatbelt: true,
        telephone: null,
        email_address: null,
        address_line_one: null,
        address_line_two: null,
        city: null,
        postcode: null,
        injury_details: null,
        has_representation: false,
        representation_company_name: null,
        representation_reference: null,
        representation_email: null,
        representation_telephone: null,
        any_lacerations: null,
        any_bleeding: null,
        any_head_wounds: null,
        any_disorientation: null,
        any_fractures_or_breaks: null,
        any_fatalities: null,
        any_loss_of_consciousness: null,
        police_attend: null,
        ambulance_or_air_ambulance_attend: null
      })
    };
  },

  computed: {
    address() {
      return {
        address_line_one: this.form.address_line_one,
        address_line_two: this.form.address_line_two,
        city: this.form.city,
        postcode: this.form.postcode
      };
    }
  },

  methods: {
    copyThirdPartyDetails() {
      if (this.thirdParty) {
        this.form.title_id = this.thirdParty.title_id;
        this.form.first_name = this.thirdParty.first_name;
        this.form.last_name = this.thirdParty.last_name;
        this.form.telephone = this.thirdParty.telephone;
        this.form.email_address = this.thirdParty.email_address;

        this.setAddress(this.thirdParty);

        window.toastify.success(
          'Complete',
          "We've copied those details for you."
        );
      }
    },

    setAddress(address) {
      this.form.address_line_one = address.address_line_one;
      this.form.address_line_two = address.address_line_two;
      this.form.city = address.city;
      this.form.postcode = address.postcode;
    },

    closeModal() {
      this.$emit('close');
    },

    addThirdPartyOccupant() {
      this.form
        .post(
          `/incidents/${this.incident}/third-parties/${this.thirdParty.identifier}/occupants`
        )
        .then(response => {
          this.$emit('added', response);
        })
        .catch(error => {
          window.toastify.error(
            'Error',
            'Sorry, there was an error creating the occupant.'
          );
        });
    }
  }
};
</script>
